export default __webpack_public_path__ + "static/media/cantplay.17b797f3.svg";